import React from 'react';
import { Search } from 'lucide-react';

interface DataToolbarProps {
  icon: React.ReactNode;
  title: string;
  count: number;
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  action?: React.ReactNode;
}

export const DataToolbar: React.FC<DataToolbarProps> = ({
  icon,
  title,
  count,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Tìm kiếm...',
  action,
}) => {
  return (
    <div className="flex items-center justify-between border-b border-[#252a38] px-5 py-4">
      <div className="flex items-center gap-2 text-[14px] font-semibold text-[#e2e8f0]">
        {icon}
        <span>{title}</span>
        <span className="rounded-full bg-[#1e2a4a] px-2 py-0.5 text-[11px] font-bold text-[#3b82f6]">
          {count}
        </span>
        {action}
      </div>
      <div className="relative">
        <Search size={14} className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-[#475569]" />
        <input
          type="text"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="w-64 rounded-lg border border-[#252a38] bg-[#0d0f14] py-1.5 pl-8 pr-2.5 text-[12px] text-[#e2e8f0] outline-none transition-colors placeholder:text-[#475569] focus:border-[#3b82f6]"
        />
      </div>
    </div>
  );
};
